"use client";

import EconomicCalendarView from "@/components/settings-view/economic-calendar/EconomicCalendarView";

export default function EconomicCalendarDesktopContent() {
  return <EconomicCalendarView variant="desktop" />;
}
